
export const appConfig = {
  "REACT_APP_ACTIVE_USE_STRIPE": false,
  "REACT_APP_COLOR": "#FFCC29",
  "REACT_APP_COLOR_ADM": "#FFCC29",
  "REACT_APP_COLOR_DARK_BACKGROUND": "#1a1a1a",
  "REACT_APP_COLOR_DARK_BORDER": "#404040",
  "REACT_APP_COLOR_DARK_CARD": "#252525",
  "REACT_APP_COLOR_DARK_DANGER": "#ff6b6b",
  "REACT_APP_COLOR_DARK_PLACEHOLDER": "#8a8a8a",
  "REACT_APP_COLOR_DARK_POLYLINE": "#dc3545",
  "REACT_APP_COLOR_DARK_PRIMARY": "#2f2f2f",
  "REACT_APP_COLOR_DARK_SECONDARY": "#6c757d",
  "REACT_APP_COLOR_DARK_SHADOW": "rgba(255, 255, 255, 0.05)",
  "REACT_APP_COLOR_DARK_STAR": "#2f2f2f",
  "REACT_APP_COLOR_DARK_SUCCESS": "#51cf66",
  "REACT_APP_COLOR_DARK_TEXT": "#ffffff",
  "REACT_APP_COLOR_DARK_TRANSPARENT": "transparent",
  "REACT_APP_COLOR_DARK_WARNING": "#ffc107",
  "REACT_APP_COLOR_DARK_WATER_COLOR": "#0077be",
  "REACT_APP_COLOR_DARK_WHITE": "#ffffff",
  "REACT_APP_COLOR_LIGHT_BACKGROUND": "#ffffff",
  "REACT_APP_COLOR_LIGHT_BLACK": "#000000",
  "REACT_APP_COLOR_LIGHT_BORDER": "#dee2e6",
  "REACT_APP_COLOR_LIGHT_CARD": "#f1f1f1",
  "REACT_APP_COLOR_LIGHT_DANGER": "#dc3545",
  "REACT_APP_COLOR_LIGHT_PLACEHOLDER": "#6c757d",
  "REACT_APP_COLOR_LIGHT_POLYLINE": "#dc3545",
  "REACT_APP_COLOR_LIGHT_PRIMARY": "#2f2f2f",
  "REACT_APP_COLOR_LIGHT_SECONDARY": "#6c757d",
  "REACT_APP_COLOR_LIGHT_SHADOW": "rgba(0, 0, 0, 0.1)",
  "REACT_APP_COLOR_LIGHT_STAR": "#2f2f2f",
  "REACT_APP_COLOR_LIGHT_SUCCESS": "#28a745",
  "REACT_APP_COLOR_LIGHT_TEXT": "#1a1a1a",
  "REACT_APP_COLOR_LIGHT_TRANSPARENT": "transparent",
  "REACT_APP_COLOR_LIGHT_WARNING": "#ffc107",
  "REACT_APP_COLOR_LIGHT_WATER_COLOR": "#3fa9f5",
  "REACT_APP_COLOR_LIGHT_WHITE": "#ffffff",
  "REACT_APP_DEACTIVATE_USE_MERCADO_PAGO_PIX": false,
  "REACT_APP_DEACTIVATE_USE_MERCADO_PAGO_PREFERENCE": false,
  "REACT_APP_DEFAULT_LANG": "PORTUGUESE_BRAZIL",
  "REACT_APP_FIREBASE_API_KEY": "AIzaSyDvNmTbahou7x7u6V2ZXkfACyzH-noXfeA",
  "REACT_APP_FIREBASE_APP_ID": "1:210047816218:web:a9229fed6e57d96353f7a3",
  "REACT_APP_FIREBASE_AUTH_DOMAIN": "wayzer-da069.firebaseapp.com",
  "REACT_APP_FIREBASE_DATABASE_URL": "https://wayzer-da069-default-rtdb.firebaseio.com",
  "REACT_APP_FIREBASE_MESSAGING_SENDER_ID": "210047816218",
  "REACT_APP_FIREBASE_PROJECT_ID": "wayzer-da069",
  "REACT_APP_FIREBASE_STORAGE_BUCKET": "wayzer-da069.firebasestorage.app",
  "REACT_APP_FIXED_THEME": "light",
  "REACT_APP_GOOGLE_MAPS_API_KEY": "AIzaSyCyOQUDhtfJhnQTZxF1dJuLT7Z52vPYo3o",
  "REACT_APP_MEASUREMENT_ID": "G-WMW7N68YNP",
  "REACT_APP_PAGOPAR_PLANS_ACTIVE": false
};

export default appConfig;
